import { ActionType } from '../actionTypes';
import { HotelNoteList, HotelNote } from './types';
import { RootAction } from '..';

export const initialState: HotelNoteList = {
  loaded: false,
  notes: [],
};

export default function hotels(state = initialState, action: RootAction): typeof initialState  {

  switch (action.type) {
    case ActionType.FETCHED_HOTEL_NOTES:
      return {loaded: true, notes: action.hotelNotes};

    case ActionType.LOGOUT_SUCCESSFUL:
      return initialState;

    case ActionType.CREATED_HOTEL_NOTE:
      return {...state, notes: [action.hotelNote, ...state.notes]};

    case ActionType.UPDATED_HOTEL_NOTE: {
      const notesAfterUpdate = state.notes.map(
        (note): HotelNote => note.id === action.hotelNote.id ? action.hotelNote : note);
      return {...state, notes: notesAfterUpdate};
    }
    case ActionType.DELETED_HOTEL_NOTE: {
      const notDeletedNotes = state.notes.filter((note): boolean => note.id !== action.hotelNoteId);
      return {...state, notes: notDeletedNotes};
    }
    default:
      return state;
  }
}